"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthorizationTokenDto = void 0;
const AppDto_1 = require("../apps/AppDto");
class AuthorizationTokenDto {
    constructor(params) {
        this.scheme = "Basic";
        this.credentials = "";
        this.createdAt = "";
        this.lastActivityAt = "";
        if (!params) {
            return;
        }
        this.id = params.id;
        this.appId = params.appId;
        this.scheme = params.scheme;
        this.credentials = params.credentials;
        this.createdAt = params.createdAt;
        this.lastActivityAt = params.lastActivityAt;
        if (params.app !== undefined) {
            this.app = params.app ? new AppDto_1.AppDto(params.app) : null;
        }
    }
}
exports.AuthorizationTokenDto = AuthorizationTokenDto;
//# sourceMappingURL=AuthorizationTokenDto.js.map